import { NavLink, useNavigate, useLocation } from "react-router-dom";
import YouelecLogo from "./YouelecLogo";
import useOnlineStatus from "@/hooks/useOnlineStatus";

export default function Navbar() {
  const nav = useNavigate();
  const online = useOnlineStatus();
  const location = useLocation();
  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition-colors ${
      isActive ? "text-[#D4AF37]" : "text-slate-300 hover:text-[#D4AF37]"
    }`;

  // Oct 2026 — Mode Chantier a son propre header mobile : la navbar fixe le
  // recouvrait et rendait le bouton retour incliquable.
  if (location.pathname.startsWith("/chantier")) return null;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-2xl bg-[#050B14]/70 border-b border-white/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <button
          onClick={() => nav("/")}
          className="group transition-transform hover:scale-105"
          data-testid="nav-logo-btn"
          aria-label="Youelec — Accueil"
        >
          <YouelecLogo variant="full" size={36} textSize="text-xl" />
        </button>

        <nav className="flex items-center gap-8">
          {!online && (
            <span
              className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wider border border-amber-400/40 bg-amber-500/10 text-amber-200"
              data-testid="offline-indicator"
              title="Connexion absente — lecture seule des données mises en cache"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse" />
              Hors-ligne
            </span>
          )}
          <NavLink to="/" className={linkClass} end data-testid="nav-accueil">
            Accueil
          </NavLink>
          <NavLink to="/menu-moi" className={linkClass} data-testid="nav-menu-moi">
            Tableau de bord
          </NavLink>
          <NavLink
            to="/menu-salarie"
            className={linkClass}
            data-testid="nav-menu-salarie"
          >
            Espace Équipe
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
